import styled from '@emotion/styled';

import { tokens, Stack } from '@hotjar/hotsauce';

export const FeaturesToggle = styled(Stack)`
  ${tokens.text('body2')};

  cursor: pointer;
  display: flex;
  justify-content: center;
  line-height: ${tokens.spacer.x2};
  padding: ${tokens.spacer.x2} 0;
`;
